import { AppRouteState, AppRouteAction } from '../types';

export const initialState: AppRouteState = {
  isLoading: false,
  hasValidParams: true,
  isDataReady: false,
  isDropdownOpened: false
};

export const appRouteReducer = (state: AppRouteState, action: AppRouteAction): AppRouteState => {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };
    case 'SET_HAS_VALID_PARAMS':
      return { ...state, hasValidParams: action.payload };
    case 'SET_IS_DATA_READY':
      return { ...state, isDataReady: action.payload };
    case 'SET_DROPDOWN_OPENED':
      return { ...state, isDropdownOpened: action.payload }
    case 'RESET_STATE':
      return { ...initialState };
    default:
      return state;
  }
};
